import { render, staticRenderFns } from "./salesDiscounts.vue?vue&type=template&id=2e4bf3b2&"
import script from "./salesDiscounts.vue?vue&type=script&lang=js&"
export * from "./salesDiscounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports